import {
  DD_ALLOWED_URLS,
  DD_APPLICATION_ID,
  DD_CLIENT_TOKEN,
  DD_PROXY,
  DD_SESSION_SAMPLE_RATE,
  ENVIRONMENT,
  GIT_VERSION,
  IS_DATADOG_ENABLED,
} from "gatsby-env-variables"

import { datadogRum } from "@datadog/browser-rum"

const init = () => {
  if (!IS_DATADOG_ENABLED) return

  const version = {
    ...(ENVIRONMENT === "production" ? { version: GIT_VERSION } : {}),
  }

  datadogRum.init({
    applicationId: DD_APPLICATION_ID,
    clientToken: DD_CLIENT_TOKEN,
    allowedTracingUrls: DD_ALLOWED_URLS,
    site: "datadoghq.com",
    service: "jn6_vehicles_www",
    env: ENVIRONMENT,
    proxy: DD_PROXY,
    version: GIT_VERSION,
    sessionSampleRate: DD_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    startSessionReplayRecordingManually: false,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    ...version,
  })
}

export default {
  init,
}
